// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__2Srwn","headerText":"Header_headerText__2cRiz"};